<template>
  <div class="editBotton m_clearLR">
    <div class="edit_box m_floatL" @click="deleteTag">
      <img src="@/../public/images/delete.png" />
      <div class="zhen_8">{{_lang[$route.query.type].zhen_8}}</div>
    </div>
    <div class="edit_box m_floatL" v-show="isRename" @click="renameTag">
      <img src="@/../public/images/rename.png" />
      <div class="zhen_9">{{_lang[$route.query.type].zhen_9}}</div>
    </div>
    <div class="edit_box m_floatR" @click="allTag">
      <img src="@/../public/images/selectAll.png" />
      <div>{{selectText}}</div>
    </div>
  </div>
</template>
<script>
import {lang} from '@/utils/i18n'
export default {
  data(){
    return{
      selectText:lang[this.$route.query.type].zhen_27,
      _lang:[]
    }
  },
  props:{
    isRename:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    deleteTag(){
      this.$emit('selectDelete')
    },
    allTag(){
      this.selectText =  this.selectText==lang[this.$route.query.type].zhen_27?lang[this.$route.query.type].zhen_28:lang[this.$route.query.type].zhen_27
      this.$emit('selectAll')
    },
    renameTag(){
      this.$emit('selectRename')
    }
  },
  created(){
    this._lang = lang
  }
}
</script>
<style lang="scss" scoped>
.editBotton{
  background-color: #0497ff;
  .edit_box{
    height:49px;
    width:33.3%;
    text-align: center;
    color:#fff;
    font-size:0.2rem;
    img{
      margin-top:0.17rem;
      width:0.36rem;
    }
  }
}
</style>

